import React, {Component} from 'react';
import firebase from '../firebase.js';
import LocationData from './LocationData.js';
import LocationInput from './LocationInput.js';
import AreaInput from './AreaInput.js';
import TimeInput from './TimeInput.js';

// Create time input component

class NewOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: '',
      area: '',
      platform: 'All Platforms',
      startTime: '',
      arriveTime: '',
      pickupTime: '',
      leaveTime: '',
      endTime: '',
      projDist: '',
      waitTime: '',
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleAreaChange = this.handleAreaChange.bind(this);
    this.handlePlatformChange = this.handlePlatformChange.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleArriveTimeChange = this.handleArriveTimeChange.bind(this);
    this.handlePickupTimeChange = this.handlePickupTimeChange.bind(this);
    this.handleLeaveTimeChange = this.handleLeaveTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.startTime = this.startTime.bind(this);
    this.arriveTime = this.arriveTime.bind(this);
    this.pickupTime = this.pickupTime.bind(this);
    this.leaveTime = this.leaveTime.bind(this);
    this.endTime = this.endTime.bind(this);
  }

  getOrderData(locationValue, platformValue) {
    firebase.database().ref('orders').on('value', (snapshot) => {
      const data = snapshot.val();
      let orders = [];

      let user;
      if (this.props.user) {
        user = this.props.user;
      } else {
        user = 'demo';
      }

      for (var order in data) {
        if (data[order].user === user) {
          orders.push({
            id: order,
            user: data[order].user,
            ...data[order],
            location: data[order].location.replace("’", "'"),
          })
        }
      }

      // let allDollarHour = orders.reduce(function(total, order) {
      //   return total + Number(order.earnings);
      // }, 0)/orders.length/(orders.reduce(function(total, order) {
      //   return total + Number(order.duration);
      // }, 0)/orders.length) * 60;

      if (locationValue) {
        orders = orders.filter(order => order.location === locationValue);
      }

      if (
        platformValue === 'DoorDash' ||
        platformValue === 'GrubHub' ||
        platformValue === 'UberEats'
      ) {
        orders = orders.filter(order => order.platform === platformValue);
      }

      const average = (category) => {
        return (
          orders.reduce(function(total, order) {
            if (isNaN(order[category])) {
              return order[category] = '';
            }
            return total + Number(order[category]);
          }, 0)/orders.length
        );
      }

      let averageTime = average('duration');
      let averageDistance = average('distance')
      let dollarOrder = average('earnings')
      let dollarHour = dollarOrder/averageTime * 60;
      let dollarMile = dollarOrder/averageDistance;

      this.__isMounted &&
      this.setState({
        location: locationValue,
        platform: platformValue,
        numberOrders: orders.length,
        averageTime: averageTime.toFixed(2),
        averageDistance: averageDistance.toFixed(2),
        dollarOrder: dollarOrder.toFixed(2),
        dollarHour: dollarHour.toFixed(2),
        dollarMile: dollarMile.toFixed(2),
      });
    });
  }

  componentDidMount() {
    this.__isMounted = true;
    this.getOrderData(this.state.location);
  }

  componentWillUnmount() {
    this.__isMounted = false;
  }

  startTime(e) {
    this.setState({
      startTime: new Date().toTimeString(),
    })
  }

  arriveTime(e) {
    this.setState({
      arriveTime: new Date().toTimeString(),
    })
  }

  pickupTime(e) {
    this.setState({
      pickupTime: new Date().toTimeString(),
    })
  }

  leaveTime(e) {
    this.setState({
      leaveTime: new Date().toTimeString(),
    })
  }

  endTime(e) {
    this.setState({
      endTime: new Date().toTimeString(),
    })
  }

  handleLocationChange(e) {
    this.getOrderData(e.target.value, this.state.platform);
    this.setState({
      location: e.target.value,
    })
  }

  handleAreaChange(e) {
    this.setState({
      area: e.target.value,
    })
  }

  handlePlatformChange(e) {
    this.getOrderData(this.state.location, e.target.value);
  }

  handleStartTimeChange(e) {
    this.setState({
      startTime: e.target.value,
    })
  }

  handleArriveTimeChange(e) {
    this.setState({
      arriveTime: e.target.value,
    })
  }

  handlePickupTimeChange(e) {
    this.setState({
      pickupTime: e.target.value,
    })
  }

  handleLeaveTimeChange(e) {
    this.setState({
      leaveTime: e.target.value,
    })
  }

  handleEndTimeChange(e) {
    this.setState({
      endTime: e.target.value,
    })
  }

  handleSubmit(e) {
    e.preventDefault();
    const newOrder = {
      order_id: Number(new Date()),
      user: this.props.user ? this.props.user : 'demo',
      date: new Date().toDateString(),
      startTime: e.target.startTime.value,
      arriveTime: e.target.arriveTime.value,
      pickupTime: e.target.pickupTime.value,
      leaveTime: e.target.leaveTime.value,
      endTime: e.target.endTime.value,
      location: e.target.location.value,
      area: e.target.area.value,
      platform: e.target.platform.value,
      duration: e.target.duration.value,
      distance: e.target.distance.value,
      projEarnings: e.target.projEarnings.value,
      earnings: e.target.earnings.value,
    }
    firebase.database().ref('orders').push(newOrder)
    this.setState({
      location: '',
      area: '',
      startTime: '',
      arriveTime: '',
      pickupTime: '',
      leaveTime: '',
      endTime: '',
    })
    e.target.elements.duration.value = '';
    e.target.elements.distance.value = '';
    e.target.elements.projEarnings.value = '';
    e.target.elements.earnings.value = '';
  }



  render() {
    console.log(this.props.user);
    return (
      <div className="mb-5">
        <div className="my-3">
          <form className="row g-3" onSubmit={this.handleSubmit}>
            <TimeInput 
              onClick={this.startTime}
              buttonName="Start"
              className="btn btn-success"
              placeholder="Start Time"
              value={this.state.startTime}
              onChange={this.handleStartTimeChange}
            />
            <TimeInput 
              onClick={this.arriveTime}
              buttonName="Arrived"
              className="btn btn-primary"
              placeholder="Arrive Time"
              value={this.state.arriveTime}
              onChange={this.handleArriveTimeChange}
            />
            <TimeInput
              onClick={this.pickupTime}
              buttonName="Pickup"
              className="btn btn-primary"
              placeholder="Pickup Time"
              value={this.state.pickupTime}
              onChange={this.handlePickupTimeChange}
            />
            <div className="col-lg-6 col-9 input-group-sm">
              <LocationInput
                location={this.state.location}
                locations={this.props.locations}
                onChange={this.handleLocationChange}
              />
            </div>
            <div className="col-3 input-group-sm">
              <input
                type="text"
                name="projEarnings"
                className="form-control"
                placeholder="Proj Earn"
              />
            </div>
            <div className="col-6 input-group-sm">
              <select
                className="form-control"
                type="text"
                name="platform"
                value={this.state.platform} onChange={this.handlePlatformChange}
              >
                <option>All Platforms</option>
                <option>DoorDash</option>
                <option>GrubHub</option>
                <option>UberEats</option>
              </select>
            </div>
            <div className="col-6 input-group-sm">
              <AreaInput
                area={this.state.area}
                areas={this.props.areas}
                onChange={this.handleAreaChange}
              />
            </div>
            <TimeInput
              onClick={this.leaveTime}
              buttonName="Leaving"
              className="btn btn-primary"
              placeholder="Leave Time"
              value={this.state.leaveTime}
              onChange={this.handleLeaveTimeChange}
            />
            <TimeInput
              onClick={this.endTime}
              buttonName="End"
              className="btn btn-danger"
              placeholder="End Time"
              value={this.state.endTime}
              onChange={this.handleEndTimeChange}
            />
            <div className="input-group-sm">
              <textarea
                type="text"
                name="duration"
                className="form-control"
                placeholder="Notes"
              />
            </div>
            <div className="col-6 input-group-sm">
              <input
                type="text"
                name="distance"
                className="form-control"
                placeholder="Distance"
              />
            </div>
            <div className="col-6 input-group-sm">
              <input
                type="text"
                name="earnings"
                className="form-control"
                placeholder="Earnings"
              />
            </div>
            <div className="col">
              <button className="btn btn-info">Add</button>
            </div>
          </form>
        </div>
        <LocationData
          dollarHour={this.state.dollarHour}
          dollarMile={this.state.dollarMile}
          numberOrders={this.state.numberOrders}
          dollarOrder={this.state.dollarOrder}
          averageTime={this.state.averageTime}
          // averageWait={this.state.averageWait}
          averageDistance={this.state.averageDistance}
          tarEarn={this.state.tarEarn}
        />
      </div>
    );
  }
}

// const Timer = (props) => {
//   const [seconds, setSeconds] = useState(0);
//   const [isActive, setIsActive] = useState(false);
//
//   function toggle() {
//     setIsActive(!isActive);
//   }
//
//   function waitTime() {
//     setSeconds(seconds)
//   }
//
//   function reset() {
//     setSeconds(0);
//     setIsActive(false);
//   }
//
//   useEffect(() => {
//     let interval = null;
//     if (isActive) {
//       interval = setInterval(() => {
//         setSeconds(seconds => seconds + 1);
//       }, 1000);
//     } else if (!isActive && seconds !== 0) {
//       clearInterval(interval);
//     }
//     return () => clearInterval(interval);
//   }, [isActive, seconds]);
//
//   return (
//     <div className="input-group-sm">
//       <button
//         className="btn btn-danger"
//         type="button"
//         onClick={reset}
//       >
//         Reset
//       </button>
//       <input
//         value={seconds}
//         onChange={props.onChange}
//         placeholder="Wait Time"
//         name="waitTime"
//       />
//       <button
//         className={`btn btn-${isActive ? 'warning' : 'primary'}`}
//         type="button"
//         onClick={toggle}
//       >
//         {isActive ? 'Pause' : 'Start'}
//       </button>
//     </div>
//   );
// };

export default NewOrder;